var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinktree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_676)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_53_676)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_53_676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 -0.00732422H0V24.5604H20V-0.00732422Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21458 16.5367H11.7681V24.5604H8.21458V16.5367ZM0 8.31248H6.04643L1.74801 4.21464L4.12647 1.76932L8.22427 5.98174V-0.00732422H11.7776V5.98174L15.8753 1.77891L18.2519 4.21464L13.9555 8.30289H20V11.6843H13.921L18.2463 15.8871L15.8753 18.2753L10.0009 12.3721L4.12647 18.2753L1.74801 15.8968L6.07501 11.6939H0V8.31248Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24.59,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_53_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24.59,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_53_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24.6043,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktree);
export default __webpack_public_path__ + "static/media/linktree.52ba62fbe6ace7c2eda1f66dfce93fca.svg";
export { ForwardRef as ReactComponent };